import styled from 'styled-components'
import { Modal, ModalHeader as ModalHeaderOriginal, ModalBody as ModalBodyOriginal } from 'reactstrap'

import { COLOURS, BREAKPOINTS } from 'resources'

import RoundedButton from 'components/RoundedButton'

const ReklaimModal = styled(Modal)`
  && {
    max-width: 650px;
  }

  .modal-content {
    padding: 15px;
    background-color: ${COLOURS.neutralWhite};
    border: none;
    border-radius: 4px;

    @media (min-width: ${BREAKPOINTS.sm}) {
      padding: 25px;
    }
  }
`

export const ModalHeader = styled(ModalHeaderOriginal)`
  padding: 0;
  border-bottom: none;

  .close {
    margin: 0;
    padding: 0 5px;
    font-size: 28px;
    line-height: 1;
    color: ${COLOURS.neutralGrey4};
    opacity: 1;
  }

  &[disabled] {
    .close {
      color: ${COLOURS.neutralGrey3};
      pointer-events: none;
    }
  }
`

export const ModalBody = styled(ModalBodyOriginal)`
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 24px;
  color: ${COLOURS.black};
  padding: 20px;

  @media (min-width: ${BREAKPOINTS.md}) {
    padding: 30px 80px;
  }
`

export const ModalIcon = styled.img`
  max-height: 50px;
  max-width: 50px;
  margin-bottom: 20px;
`

export const ModalTitle = styled.div`
  font-family: 'Druk', sans-serif;
  color: ${({ color }) => color || COLOURS.neutralBlack};
  font-size: ${({ mobileFontSize }) => mobileFontSize ?? 36}px;
  line-height: 1;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: ${({ fontSize }) => fontSize ?? 45}px;
  }
`

export const ModalDescription = styled.div`
  margin: 10px 0 25px;
  font-size: 18px;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 20px;
  }
`

export const ModalButton = styled(RoundedButton)`
  width: 100%;
  margin-top: 5px;
`

export default ReklaimModal
